import CapabilityGroup from './CapabilityGroup';

export default CapabilityGroup;
